<div *ngIf="loading">
  <mat-progress-spinner mode="indeterminate" color="primary" diameter="40" strokeWidth="4"> </mat-progress-spinner>
</div>
